/**
 * Mock COBOL Files for Testing
 *
 * Sample COBOL source code with identified paragraphs/sections
 * for the Code Editor view.
 */

// Project files - multiple COBOL and Java files per project
export const MOCK_PROJECT_FILES = {
  cobol: [
    { id: 'lgacus01', name: 'LGACUS01.cbl', path: '/COBOL/Programs/LGACUS01.cbl' },
    { id: 'lgacdb01', name: 'LGACDB01.cbl', path: '/COBOL/Programs/LGACDB01.cbl' },
    { id: 'lgicus01', name: 'LGICUS01.cbl', path: '/COBOL/Programs/LGICUS01.cbl' },
  ],
  java: [
    { id: 'customerservice', name: 'CustomerService.java', path: '/java/src/com/example/CustomerService.java' },
    { id: 'customerrepository', name: 'CustomerRepository.java', path: '/java/src/com/example/CustomerRepository.java' },
    { id: 'customercontroller', name: 'CustomerController.java', path: '/java/src/com/example/CustomerController.java' },
  ]
}

export const MOCK_COBOL_FILE = {
  name: 'LGACUS01.cbl',
  path: '/COBOL/Programs/LGACUS01.cbl',
  language: 'cobol',
  content: `       IDENTIFICATION DIVISION.
       PROGRAM-ID. LGACUS01.
      *****************************************************************
      * LGACUS01 - Customer Service Program
      *
      * This program handles customer operations including:
      * - Adding new customers
      * - Updating customer information
      * - Deleting customers
      * - Retrieving customer data
      *****************************************************************

       ENVIRONMENT DIVISION.
       CONFIGURATION SECTION.

       DATA DIVISION.
       WORKING-STORAGE SECTION.

       01  WS-HEADER.
           05  WS-TRANID           PIC X(4).
           05  WS-CUSTOMER-NUM     PIC 9(10).
           05  WS-REQUEST-TYPE     PIC X(8).
           05  WS-RETURN-CODE      PIC 9(2).

       01  WS-CUSTOMER-RECORD.
           05  WS-CUST-ID          PIC 9(10).
           05  WS-CUST-FIRST-NAME  PIC X(30).
           05  WS-CUST-LAST-NAME   PIC X(30).
           05  WS-CUST-EMAIL       PIC X(50).
           05  WS-CUST-PHONE       PIC X(15).
           05  WS-CUST-STATUS      PIC X(1).
               88  CUST-ACTIVE     VALUE 'A'.
               88  CUST-INACTIVE   VALUE 'I'.

       01  WS-FLAGS.
           05  WS-EOF-FLAG         PIC X(1) VALUE 'N'.
               88  END-OF-FILE     VALUE 'Y'.
           05  WS-ERROR-FLAG       PIC X(1) VALUE 'N'.
               88  HAS-ERROR       VALUE 'Y'.

       01  WS-CONSTANTS.
           05  WS-SUCCESS          PIC 9(2) VALUE 00.
           05  WS-NOT-FOUND        PIC 9(2) VALUE 01.
           05  WS-DUPLICATE        PIC 9(2) VALUE 02.
           05  WS-DB-ERROR         PIC 9(2) VALUE 99.

       PROCEDURE DIVISION.

      *****************************************************************
      * MAINLINE SECTION - Main program control
      *****************************************************************
       0000-MAINLINE SECTION.
           PERFORM 1000-INITIALIZE
           PERFORM 2000-PROCESS-REQUEST
           PERFORM 9000-TERMINATE
           GOBACK.
       0000-EXIT.
           EXIT.

      *****************************************************************
      * 1000-INITIALIZE - Initialize program variables
      *****************************************************************
       1000-INITIALIZE SECTION.
           INITIALIZE WS-HEADER
           INITIALIZE WS-CUSTOMER-RECORD
           INITIALIZE WS-FLAGS
           MOVE SPACES TO WS-CUST-FIRST-NAME
           MOVE SPACES TO WS-CUST-LAST-NAME
           MOVE ZEROS TO WS-RETURN-CODE
           PERFORM 1100-GET-COMMAREA.
       1000-EXIT.
           EXIT.

      *****************************************************************
      * 1100-GET-COMMAREA - Retrieve data from COMMAREA
      *****************************************************************
       1100-GET-COMMAREA SECTION.
           MOVE EIBCALEN TO WS-COMMAREA-LENGTH
           IF WS-COMMAREA-LENGTH > 0
               MOVE DFHCOMMAREA TO WS-HEADER
           END-IF.
       1100-EXIT.
           EXIT.

      *****************************************************************
      * 2000-PROCESS-REQUEST - Route to appropriate handler
      *****************************************************************
       2000-PROCESS-REQUEST SECTION.
           EVALUATE WS-REQUEST-TYPE
               WHEN 'ADD'
                   PERFORM 3000-ADD-CUSTOMER
               WHEN 'UPDATE'
                   PERFORM 4000-UPDATE-CUSTOMER
               WHEN 'DELETE'
                   PERFORM 5000-DELETE-CUSTOMER
               WHEN 'GET'
                   PERFORM 6000-GET-CUSTOMER
               WHEN OTHER
                   MOVE WS-NOT-FOUND TO WS-RETURN-CODE
           END-EVALUATE.
       2000-EXIT.
           EXIT.

      *****************************************************************
      * 3000-ADD-CUSTOMER - Add a new customer to database
      *****************************************************************
       3000-ADD-CUSTOMER SECTION.
           PERFORM 3100-VALIDATE-CUSTOMER
           IF NOT HAS-ERROR
               PERFORM 3200-INSERT-CUSTOMER-DB
           END-IF.
       3000-EXIT.
           EXIT.

      *****************************************************************
      * 3100-VALIDATE-CUSTOMER - Validate customer data
      *****************************************************************
       3100-VALIDATE-CUSTOMER SECTION.
           IF WS-CUST-FIRST-NAME = SPACES
               SET HAS-ERROR TO TRUE
               MOVE 'First name is required' TO WS-ERROR-MSG
           END-IF
           IF WS-CUST-LAST-NAME = SPACES
               SET HAS-ERROR TO TRUE
               MOVE 'Last name is required' TO WS-ERROR-MSG
           END-IF
           IF WS-CUST-EMAIL = SPACES
               SET HAS-ERROR TO TRUE
               MOVE 'Email is required' TO WS-ERROR-MSG
           END-IF.
       3100-EXIT.
           EXIT.

      *****************************************************************
      * 3200-INSERT-CUSTOMER-DB - Insert customer into DB2
      *****************************************************************
       3200-INSERT-CUSTOMER-DB SECTION.
           EXEC SQL
               INSERT INTO CUSTOMER_TABLE
               (CUST_ID, FIRST_NAME, LAST_NAME, EMAIL, PHONE, STATUS)
               VALUES
               (:WS-CUST-ID, :WS-CUST-FIRST-NAME, :WS-CUST-LAST-NAME,
                :WS-CUST-EMAIL, :WS-CUST-PHONE, 'A')
           END-EXEC

           EVALUATE SQLCODE
               WHEN 0
                   MOVE WS-SUCCESS TO WS-RETURN-CODE
               WHEN -803
                   MOVE WS-DUPLICATE TO WS-RETURN-CODE
               WHEN OTHER
                   MOVE WS-DB-ERROR TO WS-RETURN-CODE
           END-EVALUATE.
       3200-EXIT.
           EXIT.

      *****************************************************************
      * 4000-UPDATE-CUSTOMER - Update existing customer
      *****************************************************************
       4000-UPDATE-CUSTOMER SECTION.
           PERFORM 4100-FETCH-CUSTOMER
           IF NOT HAS-ERROR
               PERFORM 3100-VALIDATE-CUSTOMER
               IF NOT HAS-ERROR
                   PERFORM 4200-UPDATE-CUSTOMER-DB
               END-IF
           END-IF.
       4000-EXIT.
           EXIT.

      *****************************************************************
      * 4100-FETCH-CUSTOMER - Fetch customer for update
      *****************************************************************
       4100-FETCH-CUSTOMER SECTION.
           EXEC SQL
               SELECT CUST_ID, FIRST_NAME, LAST_NAME, EMAIL, PHONE
               INTO :WS-CUST-ID, :WS-CUST-FIRST-NAME, :WS-CUST-LAST-NAME,
                    :WS-CUST-EMAIL, :WS-CUST-PHONE
               FROM CUSTOMER_TABLE
               WHERE CUST_ID = :WS-CUSTOMER-NUM
           END-EXEC

           IF SQLCODE NOT = 0
               SET HAS-ERROR TO TRUE
               MOVE WS-NOT-FOUND TO WS-RETURN-CODE
           END-IF.
       4100-EXIT.
           EXIT.

      *****************************************************************
      * 4200-UPDATE-CUSTOMER-DB - Update customer in DB2
      *****************************************************************
       4200-UPDATE-CUSTOMER-DB SECTION.
           EXEC SQL
               UPDATE CUSTOMER_TABLE
               SET FIRST_NAME = :WS-CUST-FIRST-NAME,
                   LAST_NAME = :WS-CUST-LAST-NAME,
                   EMAIL = :WS-CUST-EMAIL,
                   PHONE = :WS-CUST-PHONE
               WHERE CUST_ID = :WS-CUST-ID
           END-EXEC

           EVALUATE SQLCODE
               WHEN 0
                   MOVE WS-SUCCESS TO WS-RETURN-CODE
               WHEN OTHER
                   MOVE WS-DB-ERROR TO WS-RETURN-CODE
           END-EVALUATE.
       4200-EXIT.
           EXIT.

      *****************************************************************
      * 5000-DELETE-CUSTOMER - Delete customer (soft delete)
      *****************************************************************
       5000-DELETE-CUSTOMER SECTION.
           EXEC SQL
               UPDATE CUSTOMER_TABLE
               SET STATUS = 'I'
               WHERE CUST_ID = :WS-CUSTOMER-NUM
           END-EXEC

           EVALUATE SQLCODE
               WHEN 0
                   MOVE WS-SUCCESS TO WS-RETURN-CODE
               WHEN 100
                   MOVE WS-NOT-FOUND TO WS-RETURN-CODE
               WHEN OTHER
                   MOVE WS-DB-ERROR TO WS-RETURN-CODE
           END-EVALUATE.
       5000-EXIT.
           EXIT.

      *****************************************************************
      * 6000-GET-CUSTOMER - Retrieve customer by ID
      *****************************************************************
       6000-GET-CUSTOMER SECTION.
           PERFORM 4100-FETCH-CUSTOMER
           IF NOT HAS-ERROR
               MOVE WS-SUCCESS TO WS-RETURN-CODE
           END-IF.
       6000-EXIT.
           EXIT.

      *****************************************************************
      * 9000-TERMINATE - Program cleanup
      *****************************************************************
       9000-TERMINATE SECTION.
           MOVE WS-HEADER TO DFHCOMMAREA
           EXEC CICS RETURN END-EXEC.
       9000-EXIT.
           EXIT.
`,
  sections: [
    // Data Division items
    {
      id: 'ws-header',
      name: 'WS-HEADER',
      displayName: 'WS-HEADER',
      type: 'working-storage',
      startLine: 30,
      endLine: 34,
      status: 'converted',
      description: 'Header record with transaction and customer info'
    },
    {
      id: 'ws-customer-record',
      name: 'WS-CUSTOMER-RECORD',
      displayName: 'WS-CUSTOMER-RECORD',
      type: 'working-storage',
      startLine: 36,
      endLine: 44,
      status: 'converted',
      description: 'Customer data record structure'
    },
    {
      id: 'ws-flags',
      name: 'WS-FLAGS',
      displayName: 'WS-FLAGS',
      type: 'working-storage',
      startLine: 46,
      endLine: 50,
      status: 'pending',
      description: 'Program control flags'
    },
    {
      id: 'ws-constants',
      name: 'WS-CONSTANTS',
      displayName: 'WS-CONSTANTS',
      type: 'working-storage',
      startLine: 52,
      endLine: 56,
      status: 'pending',
      description: 'Return code constants'
    },
    // Procedure Division - Sections
    {
      id: 'mainline',
      name: '0000-MAINLINE',
      displayName: 'MAINLINE',
      type: 'section',
      startLine: 63,
      endLine: 69,
      status: 'pending',
      description: 'Main program control - orchestrates initialization, processing, and termination'
    },
    {
      id: 'initialize',
      name: '1000-INITIALIZE',
      displayName: 'INITIALIZE',
      type: 'section',
      startLine: 74,
      endLine: 83,
      status: 'pending',
      description: 'Initialize program variables and working storage'
    },
    // Paragraphs (sub-routines within sections)
    {
      id: 'get-commarea',
      name: '1100-GET-COMMAREA',
      displayName: 'GET-COMMAREA',
      type: 'paragraph',
      startLine: 88,
      endLine: 94,
      status: 'pending',
      description: 'Retrieve data from CICS COMMAREA'
    },
    {
      id: 'process-request',
      name: '2000-PROCESS-REQUEST',
      displayName: 'PROCESS-REQUEST',
      type: 'section',
      startLine: 99,
      endLine: 113,
      status: 'pending',
      description: 'Route to appropriate handler based on request type'
    },
    {
      id: 'add-customer',
      name: '3000-ADD-CUSTOMER',
      displayName: 'ADD-CUSTOMER',
      type: 'paragraph',
      startLine: 118,
      endLine: 124,
      status: 'pending',
      description: 'Add a new customer to the database'
    },
    {
      id: 'validate-customer',
      name: '3100-VALIDATE-CUSTOMER',
      displayName: 'VALIDATE-CUSTOMER',
      type: 'paragraph',
      startLine: 129,
      endLine: 143,
      status: 'pending',
      description: 'Validate customer data before insert/update'
    },
    {
      id: 'insert-customer-db',
      name: '3200-INSERT-CUSTOMER-DB',
      displayName: 'INSERT-CUSTOMER-DB',
      type: 'paragraph',
      startLine: 148,
      endLine: 166,
      status: 'in-progress',
      description: 'Insert customer record into DB2 database'
    },
    {
      id: 'update-customer',
      name: '4000-UPDATE-CUSTOMER',
      displayName: 'UPDATE-CUSTOMER',
      type: 'paragraph',
      startLine: 171,
      endLine: 180,
      status: 'pending',
      description: 'Update existing customer information'
    },
    {
      id: 'fetch-customer',
      name: '4100-FETCH-CUSTOMER',
      displayName: 'FETCH-CUSTOMER',
      type: 'paragraph',
      startLine: 185,
      endLine: 199,
      status: 'pending',
      description: 'Fetch customer record from database for update'
    },
    {
      id: 'update-customer-db',
      name: '4200-UPDATE-CUSTOMER-DB',
      displayName: 'UPDATE-CUSTOMER-DB',
      type: 'paragraph',
      startLine: 204,
      endLine: 221,
      status: 'pending',
      description: 'Update customer record in DB2 database'
    },
    {
      id: 'delete-customer',
      name: '5000-DELETE-CUSTOMER',
      displayName: 'DELETE-CUSTOMER',
      type: 'paragraph',
      startLine: 226,
      endLine: 242,
      status: 'pending',
      description: 'Soft delete customer (set status to inactive)'
    },
    {
      id: 'get-customer',
      name: '6000-GET-CUSTOMER',
      displayName: 'GET-CUSTOMER',
      type: 'paragraph',
      startLine: 247,
      endLine: 253,
      status: 'pending',
      description: 'Retrieve customer by ID'
    },
    {
      id: 'terminate',
      name: '9000-TERMINATE',
      displayName: 'TERMINATE',
      type: 'section',
      startLine: 258,
      endLine: 262,
      status: 'pending',
      description: 'Program cleanup and return to CICS'
    }
  ]
}

// Initial Java skeleton that would be generated from analysis
export const MOCK_JAVA_SKELETON = `package com.example.customer;

import java.sql.*;
import javax.sql.DataSource;

/**
 * CustomerService - Generated from LGACUS01.cbl
 *
 * This service handles customer operations including:
 * - Adding new customers
 * - Updating customer information
 * - Deleting customers
 * - Retrieving customer data
 *
 * @generated-from LGACUS01.cbl
 * @date ${new Date().toISOString().split('T')[0]}
 */
public class CustomerService {

    private DataSource dataSource;
    private CustomerRepository customerRepository;

    public CustomerService(DataSource dataSource) {
        this.dataSource = dataSource;
        this.customerRepository = new CustomerRepository(dataSource);
    }

    // =========================================================================
    // Method stubs - To be filled by AI transformation
    // =========================================================================

    /**
     * Main entry point - orchestrates the request processing
     * @generated-stub from 0000-MAINLINE
     */
    public void processRequest(CustomerRequest request) {
        // TODO: Generated from 0000-MAINLINE SECTION
    }

    /**
     * Initialize service variables
     * @generated-stub from 1000-INITIALIZE
     */
    private void initialize() {
        // TODO: Generated from 1000-INITIALIZE SECTION
    }

    /**
     * Process the incoming request based on type
     * @generated-stub from 2000-PROCESS-REQUEST
     */
    private void routeRequest(CustomerRequest request) {
        // TODO: Generated from 2000-PROCESS-REQUEST SECTION
    }

    /**
     * Add a new customer
     * @generated-stub from 3000-ADD-CUSTOMER
     */
    public CustomerResponse addCustomer(Customer customer) {
        // TODO: Generated from 3000-ADD-CUSTOMER SECTION
        return null;
    }

    /**
     * Validate customer data
     * @generated-stub from 3100-VALIDATE-CUSTOMER
     */
    private ValidationResult validateCustomer(Customer customer) {
        // TODO: Generated from 3100-VALIDATE-CUSTOMER SECTION
        return null;
    }

    /**
     * Insert customer into database
     * @generated-stub from 3200-INSERT-CUSTOMER-DB
     */
    private void insertCustomerDb(Customer customer) throws SQLException {
        // TODO: Generated from 3200-INSERT-CUSTOMER-DB SECTION
    }

    /**
     * Update existing customer
     * @generated-stub from 4000-UPDATE-CUSTOMER
     */
    public CustomerResponse updateCustomer(Customer customer) {
        // TODO: Generated from 4000-UPDATE-CUSTOMER SECTION
        return null;
    }

    /**
     * Fetch customer for update
     * @generated-stub from 4100-FETCH-CUSTOMER
     */
    private Customer fetchCustomer(long customerId) throws SQLException {
        // TODO: Generated from 4100-FETCH-CUSTOMER SECTION
        return null;
    }

    /**
     * Update customer in database
     * @generated-stub from 4200-UPDATE-CUSTOMER-DB
     */
    private void updateCustomerDb(Customer customer) throws SQLException {
        // TODO: Generated from 4200-UPDATE-CUSTOMER-DB SECTION
    }

    /**
     * Delete customer (soft delete)
     * @generated-stub from 5000-DELETE-CUSTOMER
     */
    public CustomerResponse deleteCustomer(long customerId) {
        // TODO: Generated from 5000-DELETE-CUSTOMER SECTION
        return null;
    }

    /**
     * Get customer by ID
     * @generated-stub from 6000-GET-CUSTOMER
     */
    public Customer getCustomer(long customerId) {
        // TODO: Generated from 6000-GET-CUSTOMER SECTION
        return null;
    }

    /**
     * Cleanup and finalize
     * @generated-stub from 9000-TERMINATE
     */
    private void terminate() {
        // TODO: Generated from 9000-TERMINATE SECTION
    }
}
`

// Additional COBOL file content (simplified for demo)
export const MOCK_COBOL_FILES_CONTENT = {
  'lgacus01': MOCK_COBOL_FILE.content,
  'lgacdb01': `       IDENTIFICATION DIVISION.
       PROGRAM-ID. LGACDB01.
      *****************************************************************
      * LGACDB01 - Database Operations Program
      *****************************************************************

       ENVIRONMENT DIVISION.
       DATA DIVISION.
       WORKING-STORAGE SECTION.

       01  WS-DB-CONNECTION.
           05  WS-DB-NAME         PIC X(20).
           05  WS-DB-STATUS       PIC 9(2).

       PROCEDURE DIVISION.

       0000-MAIN SECTION.
           PERFORM 1000-CONNECT-DB
           PERFORM 2000-EXECUTE-QUERY
           PERFORM 9000-DISCONNECT
           GOBACK.
       0000-EXIT.
           EXIT.

       1000-CONNECT-DB SECTION.
           MOVE 'CUSTDB' TO WS-DB-NAME
           EXEC SQL CONNECT TO :WS-DB-NAME END-EXEC.
       1000-EXIT.
           EXIT.

       2000-EXECUTE-QUERY SECTION.
           EXEC SQL
               SELECT * FROM CUSTOMERS
           END-EXEC.
       2000-EXIT.
           EXIT.

       9000-DISCONNECT SECTION.
           EXEC SQL DISCONNECT END-EXEC.
       9000-EXIT.
           EXIT.
`,
  'lgicus01': `       IDENTIFICATION DIVISION.
       PROGRAM-ID. LGICUS01.
      *****************************************************************
      * LGICUS01 - Customer Inquiry Program
      *****************************************************************

       ENVIRONMENT DIVISION.
       DATA DIVISION.
       WORKING-STORAGE SECTION.

       01  WS-CUSTOMER-ID         PIC 9(10).
       01  WS-CUSTOMER-NAME       PIC X(50).

       PROCEDURE DIVISION.

       0000-MAIN SECTION.
           PERFORM 1000-GET-INPUT
           PERFORM 2000-LOOKUP-CUSTOMER
           PERFORM 3000-DISPLAY-RESULT
           GOBACK.
       0000-EXIT.
           EXIT.

       1000-GET-INPUT SECTION.
           ACCEPT WS-CUSTOMER-ID FROM CONSOLE.
       1000-EXIT.
           EXIT.

       2000-LOOKUP-CUSTOMER SECTION.
           EXEC SQL
               SELECT CUSTOMER_NAME
               INTO :WS-CUSTOMER-NAME
               FROM CUSTOMERS
               WHERE CUSTOMER_ID = :WS-CUSTOMER-ID
           END-EXEC.
       2000-EXIT.
           EXIT.

       3000-DISPLAY-RESULT SECTION.
           DISPLAY WS-CUSTOMER-NAME.
       3000-EXIT.
           EXIT.
`
}

// Additional Java file content
export const MOCK_JAVA_FILES_CONTENT = {
  'customerservice': MOCK_JAVA_SKELETON,
  'customerrepository': `package com.example.customer;

import java.sql.*;
import javax.sql.DataSource;
import java.util.Optional;
import java.util.List;
import java.util.ArrayList;

/**
 * CustomerRepository - Data access layer for Customer entity
 * @generated-from LGACDB01.cbl
 */
public class CustomerRepository {

    private DataSource dataSource;

    public CustomerRepository(DataSource dataSource) {
        this.dataSource = dataSource;
    }

    /**
     * Find customer by ID
     */
    public Optional<Customer> findById(long customerId) {
        // TODO: Implement from COBOL
        return Optional.empty();
    }

    /**
     * Find all customers
     */
    public List<Customer> findAll() {
        // TODO: Implement from COBOL
        return new ArrayList<>();
    }

    /**
     * Save customer
     */
    public Customer save(Customer customer) {
        // TODO: Implement from COBOL
        return customer;
    }

    /**
     * Delete customer by ID
     */
    public void deleteById(long customerId) {
        // TODO: Implement from COBOL
    }
}
`,
  'customercontroller': `package com.example.customer;

import org.springframework.web.bind.annotation.*;
import org.springframework.http.ResponseEntity;

/**
 * CustomerController - REST API endpoints for Customer operations
 * @generated-from LGICUS01.cbl
 */
@RestController
@RequestMapping("/api/customers")
public class CustomerController {

    private final CustomerService customerService;

    public CustomerController(CustomerService customerService) {
        this.customerService = customerService;
    }

    /**
     * Get customer by ID
     */
    @GetMapping("/{id}")
    public ResponseEntity<Customer> getCustomer(@PathVariable long id) {
        // TODO: Implement
        return ResponseEntity.ok(customerService.getCustomer(id));
    }

    /**
     * Create new customer
     */
    @PostMapping
    public ResponseEntity<CustomerResponse> createCustomer(@RequestBody Customer customer) {
        // TODO: Implement
        return ResponseEntity.ok(customerService.addCustomer(customer));
    }

    /**
     * Update customer
     */
    @PutMapping("/{id}")
    public ResponseEntity<CustomerResponse> updateCustomer(
            @PathVariable long id,
            @RequestBody Customer customer) {
        // TODO: Implement
        return ResponseEntity.ok(customerService.updateCustomer(customer));
    }

    /**
     * Delete customer
     */
    @DeleteMapping("/{id}")
    public ResponseEntity<Void> deleteCustomer(@PathVariable long id) {
        // TODO: Implement
        customerService.deleteCustomer(id);
        return ResponseEntity.noContent().build();
    }
}
`
}

export default MOCK_COBOL_FILE
